import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { environment } from "../../../environments/environment";
import { DiagnosisEventNote } from '../../models/diagnosis-event-note';
import { DiagnosisEventItem } from '../../models/diagnosis-event-item';
import { DiagnosisEventQuery } from '../../models/diagnosis-event-query';
import { ACCESS_TOKEN } from '../../storage/constants.lib';
import { DiagnosisEventQueryResult } from '../../models/diagnosis-event-query-result';
import { DiagnosisEventEditRequest } from '../../models/diagnosis-event-edit-request';
import { DiagnosisEventAsmTypeRequest } from '../../models/diagnosis-event-asm-type-request';
import { DiagnosisEventFilterValues } from '../../models/diagnosis-event-filter-values';
import { User } from '../../models/users';
import { DxEventDetail } from '../../models/dx-event-detail';
import { DxEventHccDetails } from '../../models/dx-event-hcc-details';
import { AsmFileUpdateRequest } from '../../models/asm-file-update-request';
import { ExportAsmPocRequest } from '../../models/export-asm-poc-request';
import { GetAssociatedEventsResult } from '../../models/get-associated-events-result';

@Injectable({
  providedIn: 'root'
})
export class DiagnosisEventService {

  private endpoint = `${environment.baseURL}/api/`;

  constructor(private http: HttpClient) { 
    //TODO
  }

  private getHttpOptions(params?: HttpParams) {
    const token = localStorage.getItem(ACCESS_TOKEN);
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + token);
    const httpOptions = {
      headers: headers,
      params: params
    };

    return httpOptions;
  }

  getDiagnosisEvents(query: DiagnosisEventQuery) {
    return this.http.post<DiagnosisEventQueryResult>(this.endpoint + "diagnosisevent/get-events", query, this.getHttpOptions());
  }

  //If query present overrides items list
  updateAssignedOpptyListItems(items: DiagnosisEventItem[], assignedToUser: User, batchCount: number, query?: DiagnosisEventQuery) {
    const ids = items.map(i => i.ID).toString();
    return this.http.post<any>(this.endpoint + "diagnosisevent/assigned-to", {
      EventIDs: ids,
      AssignedToID: assignedToUser.user_guid,
      AssignedToName: assignedToUser.given_name + ' ' + assignedToUser.family_name,
      BatchCount: batchCount,
      VisitID: ids && items?.length == 1 ? items[0].VisitID : null,
      DXCode: ids && items?.length == 1 ? items[0].ICDCODE : null,
      Query: query
    }, this.getHttpOptions());
  }

  updateEditListItem(request: DiagnosisEventEditRequest) {
    return this.http.post<any>(this.endpoint + "diagnosisevent/edit", request, this.getHttpOptions());
  }

  updateAsmRecordType(request: DiagnosisEventAsmTypeRequest) {
    return this.http.post<any>(this.endpoint + "diagnosisevent/update-asm-type", request, this.getHttpOptions());
  }

  getNotesByEventID(eventID: number) {
    const params = new HttpParams().set("eventID", eventID.toString());
    return this.http.get<DiagnosisEventNote[]>(this.endpoint + "diagnosisevent/notes", this.getHttpOptions(params));
  }

  getDxEventDetails(dxEventId: number) {
    return this.http.get<DxEventDetail[]>(this.endpoint + `diagnosisevent/event-details/${dxEventId}`, this.getHttpOptions());
  }

  getDxEventHccDetails(dxEventId: number, hcc: number, modelVersionId: number) {
    return this.http.get<DxEventHccDetails[]>(this.endpoint + `diagnosisevent/hcc-details/${dxEventId}/${hcc}/${modelVersionId}`, this.getHttpOptions());
  }

  updateAsmLineItems(request: AsmFileUpdateRequest) {
    return this.http.post<any>(this.endpoint + "diagnosisevent/update-asm-file-items", request, this.getHttpOptions());
  }

  AsmExport(request: ExportAsmPocRequest) {
    return this.http.post<any>(this.endpoint + "diagnosisevent/asm-poc", request, this.getHttpOptions());
  }

  getAssociatedEvents(request: DiagnosisEventEditRequest) {
    return this.http.post<GetAssociatedEventsResult>(this.endpoint + "diagnosisevent/associated-events", request, this.getHttpOptions());
  }
}